// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,optimize_code_size,server_grpc1,long_type_number
// @generated from protobuf file "aware_proto/proto/Modules.proto" (package "alive", syntax proto3)
// tslint:disable
import { Empty } from "../../google/protobuf/empty";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { StringValue } from "../../google/protobuf/wrappers";
import { Any } from "../../google/protobuf/any";
import { Place } from "./Location";
import { Event } from "./Event";
import { Person } from "./Person";
import { Event_EventType } from "./Event";
import { Intent } from "./Interaction";
import { Timestamp } from "../../google/protobuf/timestamp";
/**
 * @generated from protobuf enum alive.ClockModule.NotifyTimeInterval
 */
export var ClockModule_NotifyTimeInterval;
(function (ClockModule_NotifyTimeInterval) {
    /**
     * @generated from protobuf enum value: DEFAULT = 0;
     */
    ClockModule_NotifyTimeInterval[ClockModule_NotifyTimeInterval["DEFAULT"] = 0] = "DEFAULT";
    /**
     * @generated from protobuf enum value: DAY = 1;
     */
    ClockModule_NotifyTimeInterval[ClockModule_NotifyTimeInterval["DAY"] = 1] = "DAY";
    /**
     * @generated from protobuf enum value: HOUR = 2;
     */
    ClockModule_NotifyTimeInterval[ClockModule_NotifyTimeInterval["HOUR"] = 2] = "HOUR";
    /**
     * @generated from protobuf enum value: HALF_HOUR = 3;
     */
    ClockModule_NotifyTimeInterval[ClockModule_NotifyTimeInterval["HALF_HOUR"] = 3] = "HALF_HOUR";
    /**
     * @generated from protobuf enum value: MINUTE = 4;
     */
    ClockModule_NotifyTimeInterval[ClockModule_NotifyTimeInterval["MINUTE"] = 4] = "MINUTE";
})(ClockModule_NotifyTimeInterval || (ClockModule_NotifyTimeInterval = {}));
/**
 * @generated from protobuf enum alive.RecapView.ViewId
 */
export var RecapView_ViewId;
(function (RecapView_ViewId) {
    /**
     * @generated from protobuf enum value: WorkoutsOverall = 0;
     */
    RecapView_ViewId[RecapView_ViewId["WorkoutsOverall"] = 0] = "WorkoutsOverall";
    /**
     * @generated from protobuf enum value: WorkoutsDaily = 1;
     */
    RecapView_ViewId[RecapView_ViewId["WorkoutsDaily"] = 1] = "WorkoutsDaily";
    /**
     * @generated from protobuf enum value: ComputerUsageOverall = 2;
     */
    RecapView_ViewId[RecapView_ViewId["ComputerUsageOverall"] = 2] = "ComputerUsageOverall";
    /**
     * @generated from protobuf enum value: ComputerUsageDaily = 3;
     */
    RecapView_ViewId[RecapView_ViewId["ComputerUsageDaily"] = 3] = "ComputerUsageDaily";
    /**
     * @generated from protobuf enum value: SleepDaily = 4;
     */
    RecapView_ViewId[RecapView_ViewId["SleepDaily"] = 4] = "SleepDaily";
    /**
     * @generated from protobuf enum value: LocationsOverall = 5;
     */
    RecapView_ViewId[RecapView_ViewId["LocationsOverall"] = 5] = "LocationsOverall";
    /**
     * @generated from protobuf enum value: LocationsDaily = 6;
     */
    RecapView_ViewId[RecapView_ViewId["LocationsDaily"] = 6] = "LocationsDaily";
})(RecapView_ViewId || (RecapView_ViewId = {}));
/**
 * @generated from protobuf enum alive.ControlThermostatActionParams.TemperatureUnit
 */
export var ControlThermostatActionParams_TemperatureUnit;
(function (ControlThermostatActionParams_TemperatureUnit) {
    /**
     * @generated from protobuf enum value: UnknownTemperatureUnit = 0;
     */
    ControlThermostatActionParams_TemperatureUnit[ControlThermostatActionParams_TemperatureUnit["UnknownTemperatureUnit"] = 0] = "UnknownTemperatureUnit";
    /**
     * @generated from protobuf enum value: Fahrenheit = 1;
     */
    ControlThermostatActionParams_TemperatureUnit[ControlThermostatActionParams_TemperatureUnit["Fahrenheit"] = 1] = "Fahrenheit";
    /**
     * @generated from protobuf enum value: Celsius = 2;
     */
    ControlThermostatActionParams_TemperatureUnit[ControlThermostatActionParams_TemperatureUnit["Celsius"] = 2] = "Celsius";
})(ControlThermostatActionParams_TemperatureUnit || (ControlThermostatActionParams_TemperatureUnit = {}));
/**
 * @generated from protobuf enum alive.SonosPlaybackStatus
 */
export var SonosPlaybackStatus;
(function (SonosPlaybackStatus) {
    /**
     * @generated from protobuf enum value: UnknownPlaybackStatus = 0;
     */
    SonosPlaybackStatus[SonosPlaybackStatus["UnknownPlaybackStatus"] = 0] = "UnknownPlaybackStatus";
    /**
     * @generated from protobuf enum value: StoppedPlaybackStatus = 1;
     */
    SonosPlaybackStatus[SonosPlaybackStatus["StoppedPlaybackStatus"] = 1] = "StoppedPlaybackStatus";
    /**
     * @generated from protobuf enum value: PlayingPlaybackStatus = 2;
     */
    SonosPlaybackStatus[SonosPlaybackStatus["PlayingPlaybackStatus"] = 2] = "PlayingPlaybackStatus";
})(SonosPlaybackStatus || (SonosPlaybackStatus = {}));
/**
 * @generated from protobuf enum alive.PermissionType
 */
export var PermissionType;
(function (PermissionType) {
    /**
     * @generated from protobuf enum value: UnknownPermissionType = 0;
     */
    PermissionType[PermissionType["UnknownPermissionType"] = 0] = "UnknownPermissionType";
    /**
     * @generated from protobuf enum value: Camera = 1;
     */
    PermissionType[PermissionType["Camera"] = 1] = "Camera";
    /**
     * @generated from protobuf enum value: Voice = 2;
     */
    PermissionType[PermissionType["Voice"] = 2] = "Voice";
    /**
     * @generated from protobuf enum value: Location = 3;
     */
    PermissionType[PermissionType["Location"] = 3] = "Location";
    /**
     * @generated from protobuf enum value: Notifications = 4;
     */
    PermissionType[PermissionType["Notifications"] = 4] = "Notifications";
    /**
     * @generated from protobuf enum value: HealthKit = 5;
     */
    PermissionType[PermissionType["HealthKit"] = 5] = "HealthKit";
})(PermissionType || (PermissionType = {}));
/**
 * @generated from protobuf enum alive.HabitType
 */
export var HabitType;
(function (HabitType) {
    /**
     * @generated from protobuf enum value: UnknownHabitType = 0;
     */
    HabitType[HabitType["UnknownHabitType"] = 0] = "UnknownHabitType";
    /**
     * @generated from protobuf enum value: PlaceTransitDuration = 1;
     */
    HabitType[HabitType["PlaceTransitDuration"] = 1] = "PlaceTransitDuration";
    /**
     * @generated from protobuf enum value: PlaceStayDuration = 2;
     */
    HabitType[HabitType["PlaceStayDuration"] = 2] = "PlaceStayDuration";
    /**
     * @generated from protobuf enum value: PlaceMostRecent = 3;
     */
    HabitType[HabitType["PlaceMostRecent"] = 3] = "PlaceMostRecent";
    /**
     * @generated from protobuf enum value: PlaceTimeOfDay = 4;
     */
    HabitType[HabitType["PlaceTimeOfDay"] = 4] = "PlaceTimeOfDay";
    /**
     * @generated from protobuf enum value: PlaceFrequency = 5;
     */
    HabitType[HabitType["PlaceFrequency"] = 5] = "PlaceFrequency";
    /**
     * @generated from protobuf enum value: ActivityDuration = 6;
     */
    HabitType[HabitType["ActivityDuration"] = 6] = "ActivityDuration";
    /**
     * @generated from protobuf enum value: ActivityMostRecent = 7;
     */
    HabitType[HabitType["ActivityMostRecent"] = 7] = "ActivityMostRecent";
    /**
     * @generated from protobuf enum value: ActivityTimeOfDay = 8;
     */
    HabitType[HabitType["ActivityTimeOfDay"] = 8] = "ActivityTimeOfDay";
    /**
     * @generated from protobuf enum value: ActivityFrequency = 9;
     */
    HabitType[HabitType["ActivityFrequency"] = 9] = "ActivityFrequency";
    /**
     * @generated from protobuf enum value: PersonMostRecent = 10;
     */
    HabitType[HabitType["PersonMostRecent"] = 10] = "PersonMostRecent";
})(HabitType || (HabitType = {}));
/**
 * @generated from protobuf enum alive.EventStatus
 */
export var EventStatus;
(function (EventStatus) {
    /**
     * @generated from protobuf enum value: UnknownStatus = 0;
     */
    EventStatus[EventStatus["UnknownStatus"] = 0] = "UnknownStatus";
    /**
     * @generated from protobuf enum value: Start = 1;
     */
    EventStatus[EventStatus["Start"] = 1] = "Start";
    /**
     * @generated from protobuf enum value: End = 2;
     */
    EventStatus[EventStatus["End"] = 2] = "End";
    /**
     * @generated from protobuf enum value: During = 3;
     */
    EventStatus[EventStatus["During"] = 3] = "During";
})(EventStatus || (EventStatus = {}));
// @generated message type with reflection information, may provide speed optimized methods
class Modules$Type extends MessageType {
    constructor() {
        super("alive.Modules", [
            { no: 1, name: "clock", kind: "message", T: () => ClockModule },
            { no: 2, name: "calendar", kind: "message", T: () => CalendarModule },
            { no: 3, name: "goals", kind: "message", T: () => GoalsModule },
            { no: 4, name: "greeting", kind: "message", T: () => GreetingModule },
            { no: 5, name: "recap", kind: "message", T: () => RecapModule },
            { no: 6, name: "email", kind: "message", T: () => EmailModule },
            { no: 7, name: "automation", kind: "message", T: () => AutomationModule },
            { no: 8, name: "quiet", kind: "message", T: () => QuietModule },
            { no: 9, name: "sonos", kind: "message", T: () => SonosModule },
            { no: 10, name: "contacts", kind: "message", T: () => ContactsModule }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.Modules
 */
export const Modules = new Modules$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserGoal$Type extends MessageType {
    constructor() {
        super("alive.UserGoal", [
            { no: 1, name: "goal_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "activity_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "total_sessions", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "session_duration_mins", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 6, name: "timestamp", kind: "message", T: () => Timestamp },
            { no: 7, name: "progress_events", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Timestamp } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.UserGoal
 */
export const UserGoal = new UserGoal$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GoalProgress$Type extends MessageType {
    constructor() {
        super("alive.GoalProgress", [
            { no: 1, name: "timestamp", kind: "message", T: () => Timestamp },
            { no: 2, name: "event_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "progress", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "goal_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.GoalProgress
 */
export const GoalProgress = new GoalProgress$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RewardEarned$Type extends MessageType {
    constructor() {
        super("alive.RewardEarned", [
            { no: 1, name: "timestamp", kind: "message", T: () => Timestamp },
            { no: 2, name: "reward_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "user_goal", kind: "message", T: () => UserGoal },
            { no: 4, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.RewardEarned
 */
export const RewardEarned = new RewardEarned$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GapiToken$Type extends MessageType {
    constructor() {
        super("alive.GapiToken", [
            { no: 1, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "refresh_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "user_uids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "timestamp_granted", kind: "message", T: () => Timestamp },
            { no: 5, name: "timestamp_error", kind: "message", T: () => Timestamp },
            { no: 6, name: "error_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "error_description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "gcal", kind: "message", T: () => GapiIntegration },
            { no: 9, name: "gmail", kind: "message", T: () => GapiIntegration },
            { no: 10, name: "gcontacts", kind: "message", T: () => GapiIntegration }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.GapiToken
 */
export const GapiToken = new GapiToken$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GapiIntegration$Type extends MessageType {
    constructor() {
        super("alive.GapiIntegration", [
            { no: 1, name: "user_uids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "errors", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => GapiError }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.GapiIntegration
 */
export const GapiIntegration = new GapiIntegration$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GapiError$Type extends MessageType {
    constructor() {
        super("alive.GapiError", [
            { no: 1, name: "timestamp", kind: "message", T: () => Timestamp },
            { no: 2, name: "error_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "error_description", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.GapiError
 */
export const GapiError = new GapiError$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GapiDevParams$Type extends MessageType {
    constructor() {
        super("alive.GapiDevParams", [
            { no: 1, name: "use_whitelist", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "whitelisted_users", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.GapiDevParams
 */
export const GapiDevParams = new GapiDevParams$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ClockModule$Type extends MessageType {
    constructor() {
        super("alive.ClockModule", [
            { no: 1, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "time_interval", kind: "enum", T: () => ["alive.ClockModule.NotifyTimeInterval", ClockModule_NotifyTimeInterval] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.ClockModule
 */
export const ClockModule = new ClockModule$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CalendarModule$Type extends MessageType {
    constructor() {
        super("alive.CalendarModule", [
            { no: 1, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "time_to_leave_notifications_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "linked_calendars", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => LinkedCalendar }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.CalendarModule
 */
export const CalendarModule = new CalendarModule$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LinkedCalendar$Type extends MessageType {
    constructor() {
        super("alive.LinkedCalendar", [
            { no: 1, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "colorHexString", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.LinkedCalendar
 */
export const LinkedCalendar = new LinkedCalendar$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GoalsModule$Type extends MessageType {
    constructor() {
        super("alive.GoalsModule", [
            { no: 1, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "user_goals", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserGoal },
            { no: 3, name: "rewards_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "rewards_earned", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => RewardEarned } },
            { no: 5, name: "rewards_queued", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.GoalsModule
 */
export const GoalsModule = new GoalsModule$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GreetingModule$Type extends MessageType {
    constructor() {
        super("alive.GreetingModule", [
            { no: 1, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.GreetingModule
 */
export const GreetingModule = new GreetingModule$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QuietModule$Type extends MessageType {
    constructor() {
        super("alive.QuietModule", [
            { no: 1, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "quiet_time_intervals", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => QuietTimeInterval }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.QuietModule
 */
export const QuietModule = new QuietModule$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QuietTimeInterval$Type extends MessageType {
    constructor() {
        super("alive.QuietTimeInterval", [
            { no: 1, name: "start_time", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "end_time", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.QuietTimeInterval
 */
export const QuietTimeInterval = new QuietTimeInterval$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RecapModule$Type extends MessageType {
    constructor() {
        super("alive.RecapModule", [
            { no: 1, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "dayOfWeek", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.RecapModule
 */
export const RecapModule = new RecapModule$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EmailModule$Type extends MessageType {
    constructor() {
        super("alive.EmailModule", [
            { no: 1, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "linked_emails", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.EmailModule
 */
export const EmailModule = new EmailModule$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AutomationModule$Type extends MessageType {
    constructor() {
        super("alive.AutomationModule", [
            { no: 1, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "automation_params", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AutomationParams }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.AutomationModule
 */
export const AutomationModule = new AutomationModule$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SonosModule$Type extends MessageType {
    constructor() {
        super("alive.SonosModule", [
            { no: 1, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "refresh_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "timestamp_granted", kind: "message", T: () => Timestamp },
            { no: 4, name: "timestamp_error", kind: "message", T: () => Timestamp },
            { no: 5, name: "error_message", kind: "message", T: () => Timestamp },
            { no: 6, name: "announce_volumes", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 5 /*ScalarType.INT32*/ } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.SonosModule
 */
export const SonosModule = new SonosModule$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ContactsModule$Type extends MessageType {
    constructor() {
        super("alive.ContactsModule", [
            { no: 1, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "linked_emails", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.ContactsModule
 */
export const ContactsModule = new ContactsModule$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SonosAuthCode$Type extends MessageType {
    constructor() {
        super("alive.SonosAuthCode", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "auth_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.SonosAuthCode
 */
export const SonosAuthCode = new SonosAuthCode$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SonosResponse$Type extends MessageType {
    constructor() {
        super("alive.SonosResponse", [
            { no: 1, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.SonosResponse
 */
export const SonosResponse = new SonosResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SonosStateRequest$Type extends MessageType {
    constructor() {
        super("alive.SonosStateRequest", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.SonosStateRequest
 */
export const SonosStateRequest = new SonosStateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SonosPlaybackRequest$Type extends MessageType {
    constructor() {
        super("alive.SonosPlaybackRequest", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "group_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "playback_status", kind: "enum", T: () => ["alive.SonosPlaybackStatus", SonosPlaybackStatus] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.SonosPlaybackRequest
 */
export const SonosPlaybackRequest = new SonosPlaybackRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SonosPlayAudioClipRequest$Type extends MessageType {
    constructor() {
        super("alive.SonosPlayAudioClipRequest", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "player_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "clip_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.SonosPlayAudioClipRequest
 */
export const SonosPlayAudioClipRequest = new SonosPlayAudioClipRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SonosPlayFavoriteRequest$Type extends MessageType {
    constructor() {
        super("alive.SonosPlayFavoriteRequest", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "group_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "favorite_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.SonosPlayFavoriteRequest
 */
export const SonosPlayFavoriteRequest = new SonosPlayFavoriteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SonosHousehold$Type extends MessageType {
    constructor() {
        super("alive.SonosHousehold", [
            { no: 1, name: "household_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "groups", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SonosGroup },
            { no: 3, name: "favorites", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SonosFavorite },
            { no: 4, name: "players", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SonosPlayer }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.SonosHousehold
 */
export const SonosHousehold = new SonosHousehold$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SonosGroup$Type extends MessageType {
    constructor() {
        super("alive.SonosGroup", [
            { no: 1, name: "group_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "group_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "playback_status", kind: "enum", T: () => ["alive.SonosPlaybackStatus", SonosPlaybackStatus] },
            { no: 4, name: "household_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "player_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "coordinator_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.SonosGroup
 */
export const SonosGroup = new SonosGroup$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SonosPlayer$Type extends MessageType {
    constructor() {
        super("alive.SonosPlayer", [
            { no: 1, name: "player_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "player_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "capabilities", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.SonosPlayer
 */
export const SonosPlayer = new SonosPlayer$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SonosFavorite$Type extends MessageType {
    constructor() {
        super("alive.SonosFavorite", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "image_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "household_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.SonosFavorite
 */
export const SonosFavorite = new SonosFavorite$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SonosState$Type extends MessageType {
    constructor() {
        super("alive.SonosState", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "timestamp", kind: "message", T: () => Timestamp },
            { no: 3, name: "households", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SonosHousehold }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.SonosState
 */
export const SonosState = new SonosState$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Timer$Type extends MessageType {
    constructor() {
        super("alive.Timer", [
            { no: 1, name: "request_intent", kind: "message", T: () => Intent },
            { no: 2, name: "start_time", kind: "message", T: () => Timestamp },
            { no: 3, name: "duration_ms", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "duration_text", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.Timer
 */
export const Timer = new Timer$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Timers$Type extends MessageType {
    constructor() {
        super("alive.Timers", [
            { no: 1, name: "timers", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Timer }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.Timers
 */
export const Timers = new Timers$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AgendaRequest$Type extends MessageType {
    constructor() {
        super("alive.AgendaRequest", [
            { no: 1, name: "request_time", kind: "message", T: () => Timestamp },
            { no: 2, name: "initiator_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "agenda_owner_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "agenda_date_text", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "agenda_date", kind: "message", T: () => Timestamp },
            { no: 6, name: "request_intent", kind: "message", T: () => Intent }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.AgendaRequest
 */
export const AgendaRequest = new AgendaRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EventPref$Type extends MessageType {
    constructor() {
        super("alive.EventPref", [
            { no: 1, name: "main_event_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "field_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.EventPref
 */
export const EventPref = new EventPref$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RecapView$Type extends MessageType {
    constructor() {
        super("alive.RecapView", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "view_id", kind: "enum", T: () => ["alive.RecapView.ViewId", RecapView_ViewId] },
            { no: 3, name: "start_time", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.RecapView
 */
export const RecapView = new RecapView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HabitQuery$Type extends MessageType {
    constructor() {
        super("alive.HabitQuery", [
            { no: 1, name: "habit_type", kind: "enum", T: () => ["alive.HabitType", HabitType] },
            { no: 2, name: "activity_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "place_text", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "place_matches", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PlaceMatch },
            { no: 5, name: "person_text", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "person_matches", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PersonMatch }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.HabitQuery
 */
export const HabitQuery = new HabitQuery$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EventQuery$Type extends MessageType {
    constructor() {
        super("alive.EventQuery", [
            { no: 1, name: "event_type", kind: "enum", T: () => ["aware.Event.EventType", Event_EventType] },
            { no: 2, name: "event_text", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "main_event_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.EventQuery
 */
export const EventQuery = new EventQuery$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ETAQuery$Type extends MessageType {
    constructor() {
        super("alive.ETAQuery", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "place_text", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "place_matches", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PlaceMatch }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.ETAQuery
 */
export const ETAQuery = new ETAQuery$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PlaceMatch$Type extends MessageType {
    constructor() {
        super("alive.PlaceMatch", [
            { no: 1, name: "place_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "place_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "place_text", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.PlaceMatch
 */
export const PlaceMatch = new PlaceMatch$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PersonMatch$Type extends MessageType {
    constructor() {
        super("alive.PersonMatch", [
            { no: 1, name: "person_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "person_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "person_text", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.PersonMatch
 */
export const PersonMatch = new PersonMatch$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EmailMessage$Type extends MessageType {
    constructor() {
        super("alive.EmailMessage", [
            { no: 1, name: "timestamp", kind: "message", T: () => Timestamp },
            { no: 2, name: "email_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "snippet", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "message_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "thread_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "subject", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "from", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "to", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "cc", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "bcc", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "reply_to", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "forwarded_for", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "delivered_to", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "content_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "label_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "in_inbox", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 17, name: "is_unread", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 18, name: "is_sent", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 19, name: "is_important", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 20, name: "is_promotion", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 21, name: "content_plain", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 22, name: "content_html", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.EmailMessage
 */
export const EmailMessage = new EmailMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EmailRequest$Type extends MessageType {
    constructor() {
        super("alive.EmailRequest", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "max_results", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.EmailRequest
 */
export const EmailRequest = new EmailRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EmailResponse$Type extends MessageType {
    constructor() {
        super("alive.EmailResponse", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "emails", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => EmailMessage }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.EmailResponse
 */
export const EmailResponse = new EmailResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ContactsRequest$Type extends MessageType {
    constructor() {
        super("alive.ContactsRequest", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.ContactsRequest
 */
export const ContactsRequest = new ContactsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ContactsResponse$Type extends MessageType {
    constructor() {
        super("alive.ContactsResponse", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "persons", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Person }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.ContactsResponse
 */
export const ContactsResponse = new ContactsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MapPin$Type extends MessageType {
    constructor() {
        super("alive.MapPin", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "place_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.MapPin
 */
export const MapPin = new MapPin$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MapRoute$Type extends MessageType {
    constructor() {
        super("alive.MapRoute", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "route_polyline", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "place_uids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.MapRoute
 */
export const MapRoute = new MapRoute$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserMood$Type extends MessageType {
    constructor() {
        super("alive.UserMood", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "timestamp", kind: "message", T: () => Timestamp },
            { no: 3, name: "intent_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "text", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "sentiment", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.UserMood
 */
export const UserMood = new UserMood$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserReview$Type extends MessageType {
    constructor() {
        super("alive.UserReview", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "timestamp", kind: "message", T: () => Timestamp },
            { no: 3, name: "intent_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "text", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "sentiment", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "event", kind: "message", T: () => Event },
            { no: 7, name: "place", kind: "message", T: () => Place }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.UserReview
 */
export const UserReview = new UserReview$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TellUserActionParams$Type extends MessageType {
    constructor() {
        super("alive.TellUserActionParams", [
            { no: 1, name: "origin_user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "recipient_user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "vp", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "nl_text", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.TellUserActionParams
 */
export const TellUserActionParams = new TellUserActionParams$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ControlLightActionParams$Type extends MessageType {
    constructor() {
        super("alive.ControlLightActionParams", [
            { no: 1, name: "on", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "light_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "nl_text", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.ControlLightActionParams
 */
export const ControlLightActionParams = new ControlLightActionParams$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ControlThermostatActionParams$Type extends MessageType {
    constructor() {
        super("alive.ControlThermostatActionParams", [
            { no: 1, name: "degrees", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "unit", kind: "enum", T: () => ["alive.ControlThermostatActionParams.TemperatureUnit", ControlThermostatActionParams_TemperatureUnit] },
            { no: 3, name: "nl_text", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.ControlThermostatActionParams
 */
export const ControlThermostatActionParams = new ControlThermostatActionParams$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExactTimeConditionParams$Type extends MessageType {
    constructor() {
        super("alive.ExactTimeConditionParams", [
            { no: 1, name: "time", kind: "message", T: () => Timestamp },
            { no: 2, name: "time_text", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "date_text", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "nl_text", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.ExactTimeConditionParams
 */
export const ExactTimeConditionParams = new ExactTimeConditionParams$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DateConditionParams$Type extends MessageType {
    constructor() {
        super("alive.DateConditionParams", [
            { no: 1, name: "start", kind: "message", T: () => Timestamp },
            { no: 2, name: "end", kind: "message", T: () => Timestamp },
            { no: 3, name: "date_text", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "nl_text", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.DateConditionParams
 */
export const DateConditionParams = new DateConditionParams$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BoundedTimeConditionParams$Type extends MessageType {
    constructor() {
        super("alive.BoundedTimeConditionParams", [
            { no: 1, name: "deadline", kind: "message", T: () => Timestamp },
            { no: 2, name: "time_text", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "date_text", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "nl_text", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.BoundedTimeConditionParams
 */
export const BoundedTimeConditionParams = new BoundedTimeConditionParams$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EventAtPlaceConditionParams$Type extends MessageType {
    constructor() {
        super("alive.EventAtPlaceConditionParams", [
            { no: 1, name: "place_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "place_display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "nl_text", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.EventAtPlaceConditionParams
 */
export const EventAtPlaceConditionParams = new EventAtPlaceConditionParams$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EventConditionParams$Type extends MessageType {
    constructor() {
        super("alive.EventConditionParams", [
            { no: 1, name: "event_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "event_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "nl_text", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "event_text", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "place_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "place_display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "place_text", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.EventConditionParams
 */
export const EventConditionParams = new EventConditionParams$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EmailFromSenderConditionParams$Type extends MessageType {
    constructor() {
        super("alive.EmailFromSenderConditionParams", [
            { no: 1, name: "sender", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "nl_text", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.EmailFromSenderConditionParams
 */
export const EmailFromSenderConditionParams = new EmailFromSenderConditionParams$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EmailWithSubjectConditionParams$Type extends MessageType {
    constructor() {
        super("alive.EmailWithSubjectConditionParams", [
            { no: 1, name: "subject", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "nl_text", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.EmailWithSubjectConditionParams
 */
export const EmailWithSubjectConditionParams = new EmailWithSubjectConditionParams$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActivityStatusConditionParams$Type extends MessageType {
    constructor() {
        super("alive.ActivityStatusConditionParams", [
            { no: 1, name: "activity_category", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "event_status", kind: "enum", T: () => ["alive.EventStatus", EventStatus] },
            { no: 3, name: "nl_text", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.ActivityStatusConditionParams
 */
export const ActivityStatusConditionParams = new ActivityStatusConditionParams$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AutomationParams$Type extends MessageType {
    constructor() {
        super("alive.AutomationParams", [
            { no: 1, name: "automation_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "owner_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "timestamp_created", kind: "message", T: () => Timestamp },
            { no: 4, name: "nl_text", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "action", kind: "message", T: () => Any },
            { no: 6, name: "conditions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 7, name: "recurring", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "recurrence", kind: "message", T: () => RecurrenceParams }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.AutomationParams
 */
export const AutomationParams = new AutomationParams$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RecurrenceParams$Type extends MessageType {
    constructor() {
        super("alive.RecurrenceParams", [
            { no: 1, name: "value", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "time_unit", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "nl_text", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.RecurrenceParams
 */
export const RecurrenceParams = new RecurrenceParams$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ForceGenerateWrapperTypes$Type extends MessageType {
    constructor() {
        super("alive.ForceGenerateWrapperTypes", [
            { no: 1, name: "string", kind: "message", T: () => StringValue }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message alive.ForceGenerateWrapperTypes
 */
export const ForceGenerateWrapperTypes = new ForceGenerateWrapperTypes$Type();
/**
 * @generated ServiceType for protobuf service alive.SonosService
 */
export const SonosService = new ServiceType("alive.SonosService", [
    { name: "sendAuthCode", options: {}, I: SonosAuthCode, O: SonosResponse },
    { name: "getSonosState", options: {}, I: SonosStateRequest, O: SonosState },
    { name: "streamSonosState", serverStreaming: true, options: {}, I: SonosStateRequest, O: SonosState },
    { name: "playAudioClip", options: {}, I: SonosPlayAudioClipRequest, O: SonosResponse },
    { name: "playFavorite", options: {}, I: SonosPlayFavoriteRequest, O: SonosResponse },
    { name: "requestPlayback", options: {}, I: SonosPlaybackRequest, O: SonosResponse }
]);
/**
 * @generated ServiceType for protobuf service alive.EmailService
 */
export const EmailService = new ServiceType("alive.EmailService", [
    { name: "streamUnreadEmails", serverStreaming: true, options: {}, I: EmailRequest, O: EmailResponse },
    { name: "getEmails", options: {}, I: EmailRequest, O: EmailResponse }
]);
/**
 * @generated ServiceType for protobuf service alive.ContactsService
 */
export const ContactsService = new ServiceType("alive.ContactsService", [
    { name: "getContacts", options: {}, I: ContactsRequest, O: ContactsResponse }
]);
/**
 * @generated ServiceType for protobuf service alive.FakeServiceModules
 */
export const FakeServiceModules = new ServiceType("alive.FakeServiceModules", [
    { name: "Bar", options: {}, I: Empty, O: Empty }
]);
